export const CARGO_ID_SETTER = 127;
export const CARGO_ID_CLOSER = 128;

const ROLE_ALIASES = {
  cliente: "empresa",
};

export const normalizeRole = (role) => ROLE_ALIASES[role] || role;

export const getRoleFromUser = (user) => {
  const id_cargo = Number(user?.id_cargo);

  if (user?.profile_type) {
    switch (user.profile_type) {
      case "main":
        return "admin";
      case "empresa":
        return "empresa";
      case "profesional":
        if (id_cargo === CARGO_ID_SETTER) return "setter";
        if (id_cargo === CARGO_ID_CLOSER) return "closer";
        return "profesional";
      default:
        return "undefined";
    }
  }

  if (!user?.id_tipo) return "undefined";

  const id_tipo = Number(user.id_tipo);

  switch (id_tipo) {
    case 1:
      return "admin";
    case 2:
      return "empresa";
    case 3:
      if (id_cargo === CARGO_ID_SETTER) return "setter";
      if (id_cargo === CARGO_ID_CLOSER) return "closer";
      return "profesional";
    case 4:
      return "cliente";
    default:
      return "undefined";
  }
};

export const getRoleFromIdTipo = (id_tipo, id_cargo) =>
  getRoleFromUser({ id_tipo, id_cargo });

export const roleMatches = (userRole, requiredRoles = []) => {
  const normalizedUserRole = normalizeRole(userRole);
  return requiredRoles.some((role) => normalizeRole(role) === normalizedUserRole);
};
